<template>
	<div
		v-if="!isLoading"
		:id="`carouselPromotionBanner${identity}`"
		class="carousel slide"
		:class="additionalClass"
		data-ride="carousel"
	>
		<ol class="carousel-indicators" v-if="banners.length > 1">
			<li
				v-for="(_, index) in banners"
				:key="index"
				:data-target="`#carouselPromotionBanner${identity}`"
				:data-slide-to="index"
				:class="{ active: index === 0 }"
			></li>
		</ol>
		<div class="carousel-inner" :style="getStyle">
			<div
				v-for="(banner, index) in banners"
				:key="index"
				class="carousel-item"
				:class="{ active: index === 0 }"
			>
				<a :href="banner.data.url">
					<img :src="getImageByIdentity(banner.data)" class="d-block w-100" alt="slide" />
				</a>
			</div>
		</div>
		<template v-if="banners.length > 1">
			<div>
				<a
					v-if="additionalClass == 'homepage'"
					class="carousel-control-prev"
					:href="`#carouselPromotionBanner${identity}`"
					role="button"
					data-slide="prev"
				>
					<i class="bi bi-chevron-right"></i>
				</a>
				<a
					v-if="additionalClass == 'homepage'"
					class="carousel-control-next"
					:href="`#carouselPromotionBanner${identity}`"
					role="button"
					data-slide="next"
				>
					<i class="bi bi-chevron-left"></i>
				</a>
			</div>
		</template>
	</div>
	<div v-else>
		<shimmer width="100%" height="250px" />
	</div>
</template>
<script>
import Shimmer from '@/components/Shimmer.vue';

export default {
	name: 'SliderBanner',
	components: {
		Shimmer,
	},
	props: {
		radius: {
			type: Boolean,
			default: true,
		},
		identity: {
			type: String,
			default: 'INV',
		},
		additionalClass: {
			type: String,
			default: '',
		},
		banners: {
			type: Array,
			default: () => [],
		},
		isLoading: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		getImageByIdentity(bannerData) {
			if (this.identity === 'mobile') {
				return bannerData.image_mobile ? bannerData.image_mobile : bannerData.image;
			}

			return bannerData.image;
		},
	},
	computed: {
		getStyle() {
			return this.radius ? 'border-radius: 16px;' : '';
		},
	},
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/modules/_variables.scss';

.carousel-indicators li {
	width: 12px;
	height: 12px;
	border-radius: 100%;
	background-color: $color_ostock_primary;

	@media screen and (max-width: 540px) {
		width: 8px;
		height: 8px;
	}
}

.carousel-indicators {
	@media screen and (max-width: 540px) {
		bottom: -17px;
	}
}

.homepage {
	.carousel-indicators {
		justify-content: left;
		margin-left: 4%;
		li {
			background-color: #f6b055;
			margin-right: 6px;
			margin-left: 6px;
		}
	}

	.carousel-control-prev {
		// font-size: 35px;
		opacity: 1;
		position: absolute;
		width: 36px;
		height: 36px;
		left: -17px;
		top: 0;
		bottom: 0;
		margin-top: auto;
		margin-bottom: auto;

		background: #ffffff;
		/* Small Shadow */

		box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
		border-radius: 26px;
		transform: matrix(-1, 0, 0, 1, 0, 0);

		/* Inside auto layout */
		flex: none;
		order: 4;
		flex-grow: 0;
		z-index: 4;

		i {
			color: #616672;
		}
	}

	.carousel-control-next {
		opacity: 1;
		position: absolute;
		width: 36px;
		height: 36px;
		right: -17px;
		top: 0;
		bottom: 0;
		margin-top: auto;
		margin-bottom: auto;
		background: #ffffff;

		/* Small Shadow */
		box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
		border-radius: 26px;
		transform: matrix(-1, 0, 0, 1, 0, 0);

		/* Inside auto layout */
		flex: none;
		order: 4;
		flex-grow: 0;
		z-index: 4;

		i {
			color: #616672;
		}
	}

	.carousel-inner {
		border-radius: 5px !important;
	}
}
</style>
